import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react-lite";
import AddLocal from "components/videos/AddLocal";
const Add = observer(({ session }) => {
    return (_jsxs("div", { className: "aspect-video flex flex-col items-center justify-center bg-zinc-800 cursor-pointer", children: [session.hasVideos === false && (_jsx("p", { className: "paragraph mb-4", children: "You currently have no videos in your review session" })), _jsx("div", { className: "flex items-center gap-4", children: _jsx(AddLocal, { session: session }) })] }));
});
export default Add;
